module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 col-md-12 col-xs-12 px-6"
  }, [(_vm.busy) ? _c('div', {
    staticClass: "dummy-score-container cl-card"
  }, [_c('div', {
    staticClass: "dummy-header"
  }), _vm._v(" "), _vm._m(0)]) : _c('div', {
    staticClass: "score-container cl-card"
  }, [_c('div', {
    staticClass: "score-header"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.ct_score')) + "\n      "), _c('img', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.catScoreGuide",
      modifiers: {
        "catScoreGuide": true
      }
    }],
    attrs: {
      "src": "/static/images/ic-info-outline-black.svg",
      "alt": "classting-score"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row score-article"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "current-score"
  }, [(_vm.currentScore) ? [_c('strong', [_vm._v(_vm._s(_vm.currentScore || '-'))]), _vm._v(_vm._s(_vm.$t('common.score_value')) + "\n          ")] : [_vm._v("\n            " + _vm._s(_vm.$t('proficiency.need_cat')) + "\n          ")]], 2), _vm._v(" "), (_vm.changedScore !== 0 && _vm.currentScore) ? _c('div', {
    staticClass: "changed-score"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": ("/static/images/" + (_vm.changedScoreResource.icon)),
      "alt": "changed-score"
    }
  }), _vm._v(" "), _c('span', {
    style: ({
      'color': _vm.changedScoreResource.color
    })
  }, [_vm._v(_vm._s(Math.abs(_vm.changedScore)) + _vm._s(_vm.$t('common.score_value')))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "current-score-container"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.me')))]), _vm._v(" "), _c('div', {
    staticClass: "score-progress-bar"
  }, [_c('progress-bar', {
    attrs: {
      "value": _vm.currentScoreRate,
      "bgColor": _vm.selectedSubjectColor
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value ml-2"
  }, [_vm._v("\n            " + _vm._s(_vm.currentScore || '-') + _vm._s(_vm.$t('common.score_value')) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "average-score-container"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.average')))]), _vm._v(" "), _c('div', {
    staticClass: "score-progress-bar"
  }, [_c('progress-bar', {
    attrs: {
      "value": _vm.averageScoreRate,
      "bgColor": '#a4a4a4'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "value ml-2"
  }, [_vm._v("\n            " + _vm._s(_vm.averageScore || '-') + _vm._s(_vm.$t('common.score_value')) + "\n          ")])])])])]), _vm._v(" "), _c('CatScoreGuide', {
    attrs: {
      "id": "catScoreGuide"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row dummy-article"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-current-score"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "dummy-progress-bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-progress-bar"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-056381ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/CatScore.vue
// module id = 1550
// module chunks = 1